<header *ngIf="shouldShowHeader()">
    <dac-navbar [doubleNav]="false"></dac-navbar>
</header>
<main>
    <div class="container-fluid mt-3 mb-3">
        <div class="col-12 ml-auto mr-auto" [ngClass]="{notSeamless: 'col-lg-8'}">
            <router-outlet></router-outlet>
        </div>
    </div>
</main>


// WEBPACK FOOTER //
// ./src/app/assessments/assessments/assessments.component.html